import { Component, OnInit, Input } from '@angular/core';
import { AlertService } from '../../shared/services/alert.service';
import { ApiService } from '../../shared/services/api.service';
import { FormControlService } from '../../shared/services/form-control.service';
import { File } from '../../models/files/files.model';
import { Contained } from '../../models/editors/contained.model';
import { InlineFormBase } from '../../shared/components/base/inline-form/inline-form.base.component';

@Component({
  selector: 'swb-email-signatures',
  templateUrl: './../../shared/components/base/inline-form/inline-form.base.component.html',
  providers: [FormControlService]
})
export class EmailSignaturesComponent extends InlineFormBase<{banner: File, logo: File, html: File}> implements OnInit {
  public url = 'email-signatures';
  public headerTitle = 'Emailové podpisy';
  public get fieldsConfig(): Array<any> {
    return [
      new Contained({
        key: 'logo_id',
        label: 'Logo',
        entity: this.entity.logo,
        upload: true,
        isHalf: true,
        imgOnly: true
      }),
      new Contained({
        key: 'banner_id',
        label: 'Banner',
        entity: this.entity.banner,
        upload: true,
        isHalf: true,
        imgOnly: true
      }),
      new Contained({
        key: 'html_id',
        label: 'HTML',
        entity: this.entity.html,
        upload: true,
        isHalf: true,
        imgOnly: false,
        mimeType: 'text/html'
      })
    ];
  }
  public FormEditors: any;
  public isInitialized = false;
  public isSaving = false;

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _alertService: AlertService
  ) {
    super(
      _formService,
      _apiService,
      _alertService
    );
  }
}
